
    <video #target class="video-js" muted playsinline preload="none"></video>
  